import { render, staticRenderFns } from "./controllerInput.vue?vue&type=template&id=0886a615&"
import script from "./controllerInput.vue?vue&type=script&lang=js&"
export * from "./controllerInput.vue?vue&type=script&lang=js&"
import style0 from "./controllerInput.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports